import React, { useEffect, useState } from 'react';
import { MdAddPhotoAlternate } from 'react-icons/md';
import { reportValidationErrors } from '../../utils/tracker-diagnostics';

const imageTypes = ['image/jpeg', 'image/png', 'image/webp'];
const maxImageSize = 5000000;

export default function QrPhotoInput({ register, file, error, existingUrl, trigger }) {
  const [preview, setPreview] = useState('');
  const valid = file && imageTypes.includes(file.type) && file.size <= maxImageSize;
  const errorType = error?.type;
  useEffect(() => {
    if (errorType) reportValidationErrors({ image: { type: errorType } }, 'photo_selection');
  }, [errorType]);
  useEffect(() => {
    if (!valid) { setPreview(''); return undefined; }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file, valid]);
  const imageUrl = preview || existingUrl;
  return <div className="qr-image-upload">
    <label className="qr-image-upload-label" htmlFor="qr-image">
      {imageUrl ? <img src={imageUrl} alt="Selected QR item" /> :
        <span className="qr-image-upload-placeholder"><MdAddPhotoAlternate size={58} /></span>}
    </label>
    <div className="qr-image-upload-meta">
      {valid ? <p className="qr-image-upload-filename" title={file.name}>{file.name}</p> : null}
      <label htmlFor="qr-image" className="qr-image-upload-replace">{imageUrl ? 'Replace photo' : 'Add photo'}</label>
      <p className="qr-image-upload-limit">JPEG, PNG or WebP. Maximum 5 MB.</p>
    </div>
    <input id="qr-image" type="file" accept="image/jpeg,image/png,image/webp"
      aria-label={imageUrl ? 'Replace photo' : 'Add photo'} aria-invalid={!!error}
      aria-describedby={error ? 'qr-image-error' : undefined}
      {...register('image', { validate: {
        fileType: files => !files?.[0] || imageTypes.includes(files[0].type) || 'Choose a JPEG, PNG or WebP image',
        fileSize: files => !files?.[0] || files[0].size <= maxImageSize || 'Image must be 5 MB or smaller',
      }, onChange: () => trigger('image') })} />
    {error ? <span id="qr-image-error" role="alert" className="qr-image-upload-error">{error.message}</span> : null}
  </div>;
}
